<template>
  <div class="main-page" ref="projectPage">
    <div class="first-page more-height" ref="h2ch4Rec$co2Capt">
      <div class="font-area" :class="globalTransition">
        <div class="explain">
          <p>{{$t('projectPage.p1.title')}}</p></div>
        <div class="p1">
          <p>{{$t('projectPage.p1.p1')}}<br>
         {{$t('projectPage.p1.p2')}}</p>
        </div>
        <div class="p2">
          <p>{{$t('projectPage.p1.p3')}}<br>
         {{$t('projectPage.p1.p4')}}</p></div>
        <div class="p3">
          <p>{{$t('projectPage.p1.p5')}}<br>
        {{$t('projectPage.p1.p6')}}</p></div>
      </div>
      <transition name="fade">
        <div v-show="!hideDownBtn"
             class="p5" @mouseenter="rightArrowShow=true"
             @mouseleave="rightArrowShow=false"
             @click="jump2nextPage('h2ch4Rec$co2Capt')"
        >
          <transition name="fade">
            <div class="icon-div" :class="rightArrowShow?'show':''">
              <i class="el-icon-arrow-down"></i></div>
          </transition>
        </div></transition>
    </div>
    <projectDetail ref="h2ch4Rec$co2Capt" :tops="tops"></projectDetail>
    <otherProjects ref="co2Sep$Capt"></otherProjects>
    <div class="divider-div"> <el-divider class="divider"></el-divider></div>
    <globalPartner ref="co2Capt$reuse"></globalPartner>
    <footMenu ref="wasteWaterTreat"></footMenu>
  </div>
</template>

<script>
import projectDetail from '@/views/projectPage/detail';
import otherProjects from '@/views/projectPage/otherProjects';
import globalPartner from '@/views/projectPage/globalPartner';
import footMenu from '@/components/footMenu';

export default {
  name: 'projectPage',
  components: {
    projectDetail,
    otherProjects,
    globalPartner,
    footMenu,
  },
  data() {
    return {
      rightArrowShow: false,
      doTransition: true,
      showDiscoveryPage: false,
      hideDownBtn: false,
      tops: 0,
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true);
    this.author = this.$route.query.anchor;
    if (this.author && !isNaN(this.author.slice(0, 1))) { this.jump2nextPage('h2ch4Rec$co2Capt'); }
  },
  computed: {
    language() {
      return this.$store.getters.language;
    },
    globalTransition() {
      return this.$store.getters.globalTransition ? 'global-i18n-hide' : 'global-i18n-not-hide';
    },
    anchor() {
      return this.$route.query.anchor;
    },
  },
  watch: {
    globalTransition() {
      this.doTransition = !this.doTransition;
    },
    anchor() {
      this.jump2nextPage('h2ch4Rec$co2Capt');
    },
  },
  methods: {
    showDiscoveryBtnClick() {
      this.showDiscoveryPage = true;
      this.rightArrowShow = false;
    },
    handleScroll() {
      // eslint-disable-next-line
      if (this.$refs.projectPage === undefined) {
        return;
      }
      this.hideDownBtn = this.$refs.projectPage.scrollTop >= 40;
      this.tops = this.$refs.projectPage.scrollTop;
    },
    jump2nextPage(ref) {
      const that = this;
      if (this.$refs.projectPage === undefined) {
        return;
      }
      let distance = this.$refs.projectPage.scrollTop;
      const total = (this.$refs[ref].$el.offsetTop + this.$refs[ref].$el.offsetHeight) / 1.28;
      let step = total / 50;
      if (total > distance) {
        // eslint-disable-next-line
          scrollDown();
      } else {
        const newTotal = distance - total;
        step = newTotal / 50;
        // eslint-disable-next-line
          scrollUp();
      }


      function scrollDown() {
        if (distance < total) {
          distance += step;
          that.$refs.projectPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollDown, 8);
        } else {
          that.$refs.projectPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
      function scrollUp() {
        if (distance > total) {
          distance -= step;
          that.$refs.projectPage.scrollTop = distance;
          window.pageYOffset = total;
          setTimeout(scrollUp, 10);
        } else {
          that.$refs.projectPage.scrollTop = total;
          window.pageYOffset = total;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .main-page{
    background-image:url("../../assets/projectBG1.jpg");
    background-repeat:no-repeat;
    background-size:100% 100%;
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    .first-page{
      .font-area{
        max-width: 55% !important;
      }
    }
  }
  .more-height{
  /*  min-height: 888px;*/
  }
  .discovery-page{
    height: 100%;
    width: 100%;
  }
  p{
    margin-block-start: 0.3em!important;
    margin-block-end: 0.3em!important;
  }
</style>
<style>
  .el-carousel__indicators--outside{
    display: none!important;
  }
  .el-carousel__arrow{
    background: transparent!important;
    color: #369ff6!important;
    border: #369ff6 solid 1px!important;
  }
</style>



// WEBPACK FOOTER //
// src/views/projectPage/index.vue